import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: theme?.palette?.lightBackground?.main,
    borderRadius: 4,
  },
  iconWrapper: {
    padding: '15px',
    width: 'max-content',
  },
  icon: {
    height: '24px',
    width: '24px',
  },
  contentWrapper: {
    flex: 1,
  },
  questionWrapper: {
    padding: '15px 40px 12.5px 0px',
    borderBottom: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  question: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '22px',
    fontSize: '18px',
    '& > *': {
      overflowWrap: 'break-word',
      msWordBreak: 'break-all',
      wordBreak: 'break-word',
      msHyphens: 'auto',
      MozHyphens: 'auto',
      WebkitHyphens: 'auto',
      hyphens: 'auto',
      whiteSpace: 'pre-wrap',
      margin: 0,
      padding: 0,
      listStylePosition: 'inside',
    },
    '& > * > img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
    '& > pre': {
      background: 'black',
      color: 'white',
      padding: '5px',
    },
  },
  resultWrapper: {
    flex: 1,
  },
  submittedAnswerWrapper: {
    fontSize: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  selectedChoiceWrapper: {
    width: '50%',
    padding: '15.5px 40px 15.5px 0px',
    borderRight: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  selectedChoiceHeading: {
    fontSize: '12px',
    color: theme?.palette?.resultsPageLightTextColor?.main,
    marginBottom: '4px',
  },
  selectedChoice: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
  },
  correctChoiceWrapper: {
    width: '50%',
    padding: '15.5px 40px 15.5px 40px',
  },
  correctChoiceHeading: {
    fontSize: '12px',
    color: theme?.palette?.resultsPageLightTextColor?.main,
    marginBottom: '4px',
  },
  correctChoice: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
  },
  marksContainer: {
    padding: '10px',
    width: 'max-content',
    borderLeft: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  marksWrapper: {
    background: theme?.palette?.darkBackground?.main,
    height: '100%',
    minWidth: '73px',
    minHeight: '108px',
    borderRadius: 4,
    padding: '20px',
  },
  marks: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
    fontWeight: 600,
  },
  marksHeading: {
    fontSize: '12px',
  },
}))

export { useStyles }
